import React from 'react';
import { FiLayers } from 'react-icons/fi';
import styles from '../DonationForm.module.css';

// The one-time vs. monthly donation-type radio group. Extracted VERBATIM
// from DonationForm's render, including the original's duplicate wiring
// (each radio's onClick and its nested input's onChange run the same
// state-reset logic independently, since clicking the label already
// triggers the input's onChange too).
export default function DonationTypeSelector({
  donationType,
  onClientSecretChange,
  paymentIntentCreatedRef,
  setClientSecret,
  setDonationType,
  setError,
  setIsForever,
  setMonthlyAmount,
  setNumberOfPayments,
  setOneTimeAmount,
  setPaymentIntentId,
  setPreservedDonationType,
  setPreservedIsForever,
  setPreservedMonthlyAmount,
  setPreservedNumberOfPayments,
  setPreservedOneTimeAmount,
  setShowPaymentElement,
  setShowPaymentForm,
  setSubscriptionData,
}) {
  return (
    <div className={styles.formSection}>
      <h4 className={styles.sectionTitle}>
        <FiLayers /> Donation Type
      </h4>

      <div className={styles.radioGroup}>
        <label
          className={`${styles.radioOption} ${donationType === 'one-time' ? styles.selected : ''}`}
          onClick={() => {
            // Allow switching donation type even when payment element is shown
            setDonationType('one-time');
            setPreservedDonationType('one-time');
            setMonthlyAmount('');
            setNumberOfPayments('');
            setPreservedMonthlyAmount(null);
            setPreservedNumberOfPayments(null);
            setPreservedIsForever(false);
            // Reset payment element when switching types
            setClientSecret(null);
            setShowPaymentElement(false);
            setShowPaymentForm(false);
            setSubscriptionData(null);
            setPaymentIntentId(null);
            paymentIntentCreatedRef.current = false;
            setError('');
            // Clear parent's clientSecret if callback exists
            if (onClientSecretChange) {
              onClientSecretChange(null);
            }
          }}
        >
          <input
            type="radio"
            name="donationType"
            value="one-time"
            checked={donationType === 'one-time'}
            onChange={() => {
              setDonationType('one-time');
              setPreservedDonationType('one-time');
              setMonthlyAmount('');
              setNumberOfPayments('');
              setPreservedMonthlyAmount(null);
              setPreservedNumberOfPayments(null);
              setPreservedIsForever(false);
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setSubscriptionData(null);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              setError('');
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }}
          />
          <span className={styles.radioLabel}>
            One-Time Donation
          </span>
        </label>

        <label
          className={`${styles.radioOption} ${donationType === 'monthly' ? styles.selected : ''}`}
          onClick={() => {
            setDonationType('monthly');
            setPreservedDonationType('monthly');
            setOneTimeAmount('');
            setPreservedOneTimeAmount(null);
            setIsForever(false);
            setNumberOfPayments('');
            setClientSecret(null);
            setShowPaymentElement(false);
            setShowPaymentForm(false);
            setSubscriptionData(null);
            setPaymentIntentId(null);
            paymentIntentCreatedRef.current = false;
            setError('');
          }}
        >
          <input
            type="radio"
            name="donationType"
            value="monthly"
            checked={donationType === 'monthly'}
            onChange={() => {
              setDonationType('monthly');
              setPreservedDonationType('monthly');
              setOneTimeAmount('');
              setPreservedOneTimeAmount(null);
              setIsForever(false);
              setNumberOfPayments('');
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setSubscriptionData(null);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              setError('');
            }}
          />
          <span className={styles.radioLabel}>
            Monthly Recurring Donation
          </span>
        </label>
      </div>
    </div>
  );
}
